const isIBMInstance = false;
const isCohesityInstance = true;
const isSimpleSizer = true;

export const environment = {
  production: true,
  http: {
    baseUrl: '',
  },
  headerString: 'WEB SIZING TOOL',
  headerStringForSimpleSizer : 'SIMPLE-SIZER',
  disable_console: true,
  enableDataHawk: isCohesityInstance && !isIBMInstance,
  enableCCSConnectorSizing: true,
  isArchiveToTapeEnabled: isCohesityInstance && !isIBMInstance,
  isSmartFilesSizerEnabled: isCohesityInstance && !isIBMInstance,
  isCCSEnabled: isCohesityInstance && !isIBMInstance,
  isFortKnoxVaultingEnabled: true,
  isBundleLicensingEnabled: isCohesityInstance && !isIBMInstance,
  isIBMInstance: isIBMInstance,
  isCohesityInstance: isCohesityInstance,
  enableMetadataSizing: true,
  enableFKCAv2: false,
  enableHeterogeneousClusters: true,
  enableCustomDataReduction: true,
  enableClusterWideLimit: false,
  isSimpleSizer,
  isMalwareScanningEnabled: !isCohesityInstance && !isIBMInstance, // disable for prod as of now since we don't have all the queries resolved
  isNBUClusterEnabled: isCohesityInstance && !isIBMInstance, // disable NBU cluster for prod only for now till final perf numbers
  isM365Enabled: isCohesityInstance && !isIBMInstance,
  isSecondCopyRegionEnabled: isCohesityInstance && !isIBMInstance,
  isNodeForgeEnable: isCohesityInstance && !isIBMInstance,
  nodeForgeHref: '/v2/',
  whatsNewLink: "https://cohesity-my.sharepoint.com/:f:/p/sreehari_govind/IgC222Qkb4RtSbwmRtNbXGXLAQDPUiPl7dRHgYXKddj2DgM?e=CGmUT3",
  isRhovEnabled: isCohesityInstance && !isIBMInstance,
  isJanusEnabled: isCohesityInstance && !isIBMInstance,
};
